import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/theme.css';
import './utils/httpInterceptor';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
